import { Modal } from "@common/Modal";
import i18n from "@service/locale/i18";

export const getUnknownProfileErrorMessage = (profileId: string) => {
    return i18n.t("expert-ratings.errors.unknownProfile", { profileId: profileId }).toString()
}


export const showDataErrorModal = async (contentText: string) => {
    const modal = new Modal({
        title: i18n.t("expert-ratings.errors.dataError").toString(),
        contentText,
        buttons: [
            {
                text: 'Ok',
                class: 'is-green is-middle',
                returnValue: true
            }
        ]
    });

    return (await modal.showConfirm()) as string | boolean;
}